import React from "react";
import { PageHero, PageBody, formatDate } from "./_shared";
import { useFood } from "./FoodLayout";
import { FileText, ExternalLink, GraduationCap } from "lucide-react";

export default function Admissions() {
  const data = useFood();
  const inst = data.institute || {};
  const notices = data.notices_admission || [];

  return (
    <div data-testid="ft-admissions">
      <PageHero eyebrow="Admissions 2025–26" title="Apply, visit, ask" subtitle="Take the next step. Our admissions team is here to walk you through eligibility, dates, and document checklists." accent="orange" />
      <PageBody>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="md:col-span-2">
            <h2 className="font-serif text-2xl text-[#0F1F17] mb-4">Latest Admission Notices</h2>
            <div className="space-y-3">
              {notices.length === 0 && (
                <div className="bg-white rounded-md p-8 text-center text-sm text-[#4D5A52] ring-1 ring-[#E6E2D6]">
                  No admission notices have been posted yet. Reach out to us using the details on the right.
                </div>
              )}
              {notices.map((n) => (
                <a key={n.id} href={n.file_url || n.external_url || "#"} target="_blank" rel="noopener noreferrer"
                   className="block bg-white rounded-md p-4 ring-1 ring-[#E6E2D6] hover:ring-[#F4751F] transition-colors">
                  <div className="flex items-start gap-3">
                    <FileText className="text-[#F4751F] mt-0.5" size={18} />
                    <div className="flex-1">
                      <div className="text-[10px] uppercase tracking-wider text-[#1F6B3F] font-semibold">{formatDate(n.posted_on || n.notice_date)}</div>
                      <div className="text-sm mt-1 text-[#0F1F17] font-medium">{n.title}</div>
                    </div>
                    <ExternalLink className="text-[#4D5A52]" size={14} />
                  </div>
                </a>
              ))}
            </div>
          </div>
          <aside className="bg-[#1F6B3F] text-white rounded-lg p-7">
            <GraduationCap size={24} strokeWidth={1.5} className="text-[#F4751F]" />
            <h3 className="mt-2 font-serif text-xl">Talk to admissions</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {inst.admission_phone && <li>📞 <a href={`tel:${inst.admission_phone.replace(/\s+/g, "")}`} className="hover:text-[#F4751F]">{inst.admission_phone}</a></li>}
              {inst.email && <li>✉️ <a href={`mailto:${inst.email}`} className="hover:text-[#F4751F]">{inst.email}</a></li>}
              {inst.whatsapp_phone && <li>💬 <a href={`https://wa.me/${inst.whatsapp_phone.replace(/[^0-9]/g, "")}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#F4751F]">WhatsApp us</a></li>}
            </ul>
            <p className="mt-5 text-[11px] text-white/70 leading-relaxed">
              Eligibility, document checklist, and fee structure shared on request. We can also schedule a campus visit or virtual tour.
            </p>
          </aside>
        </div>
      </PageBody>
    </div>
  );
}
